import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit';
import * as API from '../../core/utils/auth-utils';
import {   TokenResponse, HttpError} from '../../core/models';
import { Documents, SignupRequest } from '../model/singup-model';
import { get, values,uniqBy } from 'lodash';
const initialState = {
  isLoading: false,
  error: '',
  step: 0,
  showOTP: false,
  userId: undefined,
  user: {
    document: [] as Documents[]
  }   ,
  userProfile:{}
};

/**
 * Thunks Actions
 */
const signup = createAsyncThunk<any, any, any>(
  'signup/post',
  async (request: SignupRequest, thunkAPI) => {
    starLoading()
    const response: any = await API.getAuthToken(request);
    if (response.status === 400) {
      return thunkAPI.rejectWithValue((await response.json()) as HttpError);
    }

    const tokenResponse = await response.json();
    onSignupSuccess(tokenResponse);
    endLoading()
    return tokenResponse;
  },
);

/**
 * Reducers
 */
const signupReducer = createSlice({
  name: 'signup',
  initialState: initialState,
  reducers: {
    changeStep(state: any, action:any) {
      state.step = action.payload;
    },
    onSignupSuccess(state) {
      // state.isLogin = true;
      // //TODO correct this with actual flow
      // state.onboardCompleted = true;
      // state.isForgotPasswordFlow = false;
      //state.token = payload.token;
    },
    starLoading(state) {
      state.isLoading = true;
    },
    endLoading(state) {
      state.isLoading = false;
    },
    setShowOTP(state,action: any) {
      state.showOTP = action.payload;
    },
    setUserId(state,action: any) {
      state.userId = action.payload;
    },
    setUser(state: any, action : any) {
      state.user={...state.user, ...(action.payload|| {}) }
    },
    pushDocuments(state: any, action : any) {
      let document=get(state,"user.document",[]).map((d: Documents) => ({...d}));
      document=uniqBy(document.concat(action.payload),"type")
      state.user={...state.user, document }
    },
    resetSignup(state: any, _action : any){
      state.user={}
    }

  },
  extraReducers: (builder) => {
    builder.addCase(
      signup.fulfilled,
      (state, {payload}: PayloadAction<TokenResponse>) => {
         state.isLoading = true;

      },
    );
    builder.addCase(signup.rejected, (state:any, action) => {
      state.isLoading = false;
      if (action.payload) {
        // Since we passed in `MyKnownError` to `rejectType` in `updateUser`, the type information will be available here.

        state.error = action.error;
      }
    });
  },
});

/*Actions export*/
const {
  onSignupSuccess,
  starLoading,
  endLoading,
  changeStep,
  setShowOTP,
  setUserId,
  setUser,
  pushDocuments,
  resetSignup
} = signupReducer.actions;
export {
  signup,
  onSignupSuccess,
  starLoading,
  endLoading,
  changeStep,
  setShowOTP,
  setUserId,
  setUser,
  pushDocuments,
  resetSignup
};
/*Reducer export*/
export default signupReducer;
